import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover'
import { Filter } from 'iconsax-react'

export const BasicFilter = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex items-center justify-between">
      <Popover>
        <PopoverTrigger>
          <div className="flex cursor-pointer items-center gap-2 rounded-lg border-[1px] border-gray01 px-3 py-2">
            <Filter size="20" />
            <p className="text-xs font-semibold">Filtrar</p>
          </div>
        </PopoverTrigger>
        <PopoverContent className="w-[346px] p-0" align="end">
          <div className="flex items-center justify-between px-5 pt-6">
            <h2 className="font-medium">Filtrar</h2>
          </div>
          <div className="my-4 w-full border-b-[1px] border-gray01" />
          {children}
        </PopoverContent>
      </Popover>
    </div>
  )
}
